module.exports = __webpack_public_path__ + "static/media/43 - Tom Tom Club - Genius Of Love.93432fdb.mp3";